<script>
    export let size = 14
    export let color = 'white'
    export let style = ''
    export let title = null
</script>

<svg
    {style}
    width={`${size}`}
    height={`${size * (5 / 7)}`}
    viewBox="0 0 14 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    {#if title}
        <title>{title}</title>
    {/if}
    <path
        d="M1 4.5L5.17572 8.84971C5.25443 8.9317 5.38557 8.9317 5.46428 8.84971L13 1"
        stroke={color}
        stroke-width={`${size * (3 / 20)}`}
        stroke-linecap="round"
    ></path>
</svg>
